import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseComponent, DataTableRequest, EditComponent, LanguageService, OneColumnSearchData, SearchData, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { CoreService, ResourceModel } from 'src/app/services/api-services';
import { Location } from '@angular/common';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ResourceEditComponent } from '../resource-edit/resource-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ADTSettings } from 'angular-datatables/src/models/settings';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
    selector: 'app-resource-list',
    templateUrl: './resource-list.component.html',
    styleUrls: ['./resource-list.component.scss'],
})
export class ResourceListComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<EditComponent>;
    public item: ResourceModel;

    constructor(private router: Router, private translatedToastrService: TranslatedToastrService, private translateService: TranslateService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService, protected override languageService: LanguageService, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }

    public override getDtOptions() {
        this.languageUrl = this.languageService.getTranslationUrl();

        const res: ADTSettings = {
            serverSide: true,
            processing: false,
            pageLength: 20,
            lengthChange: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                },
            },
            searching: false,
            destroy: true,
            language: {
                url: this.languageUrl,
            },
            ajax: (dataTablesParams: any, callback: any) => {
                const searchData: OneColumnSearchData = {
                    propertyValue: this.searchValue,
                };

                for (let order of dataTablesParams.order) {
                    order.name = dataTablesParams.columns[order.column]?.data;
                }

                const model: DataTableRequest = {
                    draw: dataTablesParams.draw,
                    start: dataTablesParams.start,
                    length: dataTablesParams.length,
                    order: dataTablesParams.order,
                    search: searchData,
                    columns: this.transformToColumnData(this.dtOptions.columns),
                };

                this.datatableRequest = model;

                this.handleSpinner(firstValueFrom(this.coreService.getResourceListDataSource(model)))
                    .then(res => {
                        callback(this.getTableData(res));
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                        callback(this.getEmptyTableData());
                    });
            },
            columns: [
                {
                    data: 'key',
                    title: 'common.key',
                    responsivePriority: 1,
                    searchable: true,
                    orderable: true,
                },
                {
                    data: 'language',
                    title: 'resource.language',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'value',
                    title: 'common.value',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'type',
                    title: 'common.type',
                    searchable: false,
                    orderable: true,
                },
                {
                    title: 'common.actions',
                    data: null,
                    searchable: false,
                    orderable: false,
                    defaultContent: '',
                    ngTemplateRef: {
                        ref: this.actionsRef,
                        context: {
                            captureEvents: this.onEditItem.bind(this),
                        },
                    },
                    responsivePriority: 1,
                },
                {
                    data: '',
                    orderable: false,
                    responsivePriority: 1,
                    render: function (data) {
                        return '';
                    },
                },
            ],
            columnDefs: [
                {
                    targets: '_all',
                    visible: true,
                },
                {
                    className: 'details-icon dtr-control',
                    orderable: false,
                    target: -1,
                },
            ],
        };

        return res;
    }

    public onSearch(event: string): void {
        this.searchValue = event;
        this.refreshDataTable();
    }
    public ngAfterViewInit() {
        this.dataTableAfterViewInit();
    }

    public ngOnDestroy() {
        this.dataTableOnDestroy();
    }

    public ngOnInit() {
        this.dataTableOnInit();
    }
    public onEditItem(event: any) {
        this.openEditModalWithComponent(event.data);
    }

    public openEditModalWithComponent(item: ResourceModel) {
        let modalOptions: ModalOptions = this.getDefaultModalOptions('menu.resource_list', item);

        let bsModalRef: BsModalRef = this.modalService.show(ResourceEditComponent, modalOptions);
        bsModalRef.onHide.subscribe((reason: string | any) => {
            if (reason === 'save_success') {
                this.translatedToastrService.success('common.save_success', 'common.success');
                this.refreshDataTable();
            }
        });
    }
}
